/**
 * Actions
 */
export const GET_WORKSPACE_LIST = 'GET_WORKSPACE_LIST'

export const GET_APP_VERSION_LIST = 'GET_APP_VERSION_LIST'

export const EDIT_WORKSPACE = 'EDIT_WORKSPACE'

export const DELETE_WORKSPACE = 'DELETE_WORKSPACE'

export const GET_WORKSPACE_COMPONENTS_LIST = 'GET_WORKSPACE_COMPONENTS_LIST'

export const ADD_COMPONENT_QUOTES = 'ADD_COMPONENT_QUOTES'

export const GET_WORKSPACE_QUOTES_COMPONENTS_LIST = 'GET_WORKSPACE_QUOTES_COMPONENTS_LIST'

export const DELETE_COMPONENT_QUOTES = 'DELETE_COMPONENT_QUOTES'

export const UPDATE_COMPONENT_QUOTES_VERSION = 'UPDATE_COMPONENT_QUOTES_VERSION'

export const GET_APP_VERSION = 'GET_APP_VERSION'

export const GET_ENGINE_VERSION = 'GET_ENGINE_VERSION'

export const GET_ENV_LIST = 'GET_ENV_LIST'

export const GET_APP_VERSION_ENV_LIST = 'GET_APP_VERSION_ENV_LIST'

export const DELETE_APP_VERSION = 'DELETE_APP_VERSION'

export const GET_ROLES_LIST = 'GET_ROLES_LIST'

export const ADD_ROLE = 'ADD_ROLE'

export const DELETE_ROLE = 'DELETE_ROLE'

export const UPDATE_ROLE = 'UPDATE_ROLE'

export const CREATE_BRANCH = 'CREATE_BRANCH'

export const SELECT_DEFAULT_BRANCH = 'SELECT_DEFAULT_BRANCH'

export const GET_BRANCH_TAGS = 'GET_BRANCH_TAGS'

export const GET_SELECTED_BRANCH = 'GET_SELECTED_BRANCH'
/**
 * Mutations
 */
export const SET_WORKSPACE_LIST = 'SET_WORKSPACE_LIST'

export const SET_WORKSPACE_COMPONENTS_LIST = 'SET_WORKSPACE_COMPONENTS_LIST'

export const SET_APP_INFO = 'SET_APP_INFO'

export const SET_CURRENT_WORKSPACE = 'SET_CURRENT_WORKSPACE'

export const SET_ROLES_LIST = 'SET_ROLES_LIST'

export const UPDATE_WORKSPACE_LOADING = 'UPDATE_WORKSPACE_LOADING'
